<template>
  <figure
    v-if="props.image.filename"
    class="header-background"
    :class="{ 'desktop-image': !isMobile, 'mobile-image': isMobile }"
  >
    <!-- https://www.storyblok.com/docs/image-service -->
    <img
      v-if="image.filename"
      :alt="image.alt"
      :src="`${image.filename}/m/${isMobile ? '400x0' : '1000x0'}`"
      :title="image.title"
    />
  </figure>
</template>

<script setup>
const props = defineProps({
  image: {
    type: Object,
    required: false,
    default: () => {}
  },
  isMobile: {
    type: Boolean,
    required: false,
    default: true
  }
})
</script>

<style scoped>
.header-background.mobile-image {
  width: 100%;
  max-width: 180px;
  display: none;
  margin: 0;
}

.header-background.desktop-image {
  display: block;
  max-width: 610px;
}

.header-background img {
  max-width: 100%;
}

@media (min-width: 576px) {
  .header-background {
    margin-left: -20px;
  }
}

@media (max-width: 576px) {
  .header-background.mobile-image {
    display: block;
  }

  .header-background.desktop-image {
    display: none;
  }
}
</style>
